import PropTypes from 'prop-types';
import Image from 'next/image';
import Text from '@hiredigital/ui/Text/Text';
import { Section, SectionContainer } from '@components/Section';
import Column from '@components/Column/Column';

import Styles from './CompanyWorkflow.module.scss';

const Workflow = ({ isEnterprise = false }) => {
  return (
    <SectionContainer anchor='howitworks'>
      <Section textColor={isEnterprise && Text.Color.WHITE} title={`How Hire Digital Works`}>
        <Column.List>
          <Column.Item className={isEnterprise && Styles.enterpriseItem}>
            <Column.Image type={Column.Image.Type.ICON}>
              <Image
                height={75}
                width={75}
                className={Styles.image}
                title='one'
                alt='one'
                src={`/img/count/one.svg`}
              />
            </Column.Image>
            <Column.Headline
              className={isEnterprise && Styles.whiteText}>{`Speak to us`}</Column.Headline>
            <Column.Content className={isEnterprise && Styles.whiteText}>
              {`Tell our marketing and growth experts (not recruiters) your business goals and project needs.`}
            </Column.Content>
          </Column.Item>
          <Column.Item className={isEnterprise && Styles.enterpriseItem}>
            <Column.Image type={Column.Image.Type.ICON}>
              <Image
                height={75}
                width={75}
                className={Styles.image}
                title='two'
                alt='two'
                src={`/img/count/two.svg`}
              />
            </Column.Image>
            <Column.Headline
              className={
                isEnterprise && Styles.whiteText
              }>{`Get introduced to top talent`}</Column.Headline>
            <Column.Content className={isEnterprise && Styles.whiteText}>
              {`We can find you the talent you need in as fast as 24 hours.`}
            </Column.Content>
          </Column.Item>
          <Column.Item className={isEnterprise && Styles.enterpriseItem}>
            <Column.Image type={Column.Image.Type.ICON}>
              <Image
                height={75}
                width={75}
                className={Styles.image}
                title='three'
                alt='three'
                src={`/img/count/three.svg`}
              />
            </Column.Image>
            <Column.Headline
              className={isEnterprise && Styles.whiteText}>{`Start work`}</Column.Headline>
            <Column.Content className={isEnterprise && Styles.whiteText}>
              {`Work with your hand-picked talent right away. We provide trials and guarantees to ensure fit.`}
            </Column.Content>
          </Column.Item>
        </Column.List>
      </Section>
    </SectionContainer>
  );
};

Workflow.propTypes = {
  textColor: PropTypes.string,
};

export default Workflow;
